import { render, staticRenderFns } from "./CancelOrder.vue?vue&type=template&id=56a7100d&lang=pug&"
import script from "./CancelOrder.vue?vue&type=script&lang=ts&"
export * from "./CancelOrder.vue?vue&type=script&lang=ts&"
import style0 from "./CancelOrder.vue?vue&type=style&index=0&id=56a7100d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports